import React from 'react';
import { Heart, Users, Calendar, MessageCircle, Sparkles, ArrowRight, CheckCircle2 } from 'lucide-react';
import { DarkCard, CheckListItem } from '../components/Cards';
export function ComunitateRise() {
  return <div className="bg-rise-white min-h-screen" data-id="element-446">
      {/* 1. Hero Section */}
      <section className="bg-rise-black text-rise-white py-12 md:py-20 px-6 relative overflow-hidden" data-id="element-447">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-448">
          <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[100%] bg-rise-gold/5 blur-[120px] rounded-full" data-id="element-449"></div>
        </div>
        <div className="max-w-rise-content mx-auto flex justify-center relative z-10" data-id="element-450">
          <div className="flex flex-col items-center text-center max-w-3xl" data-id="element-451">
            <div className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-452">
              ABONAMENT LUNAR
            </div>
            <h1 className="font-playfair text-[36px] md:text-[52px] leading-tight mb-6" data-id="element-453">
              Comunitatea R.I.S.E.
            </h1>
            <p className="font-dm-sans text-[19px] text-rise-white/80 max-w-xl mx-auto leading-relaxed mb-10" data-id="element-454">
              Spațiul tău de siguranță, creștere și conexiune autentică.
              Alătură-te unui grup de oameni care împărtășesc aceleași valori și
              dorința de evoluție continuă.
            </p>
            <div className="flex justify-center w-full" data-id="element-455">
              <a href="#abonament" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors flex items-center justify-center gap-2 w-full max-w-md" data-id="element-456">
                Vreau în Comunitate <ArrowRight size={18} data-id="element-457" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 2. De ce ai nevoie de un trib? - title centered, paragraphs left-aligned */}
      <section className="py-12 md:py-20 px-6 bg-rise-white text-rise-black" data-id="element-458">
        <div className="max-w-3xl mx-auto" data-id="element-459">
          <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black text-center mb-12" data-id="element-460">
            De ce ai nevoie de un "trib"?
          </h2>
          <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed mb-6 text-left" data-id="element-461">
            Evoluția personală poate fi adesea un drum singuratic. Când începi
            să te schimbi, să pui limite și să îți ridici standardele, s-ar
            putea să simți că nu te mai potrivești în vechile cercuri sociale.
          </p>
          <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed text-left" data-id="element-462">
            Comunitatea R.I.S.E. a fost creată exact pentru a umple acest gol.
            Este locul unde nu ești judecat, unde ești susținut în momentele
            grele și celebrat în momentele de succes. Creștem mai repede și mai
            frumos atunci când o facem împreună.
          </p>
        </div>
      </section>

      {/* 3. Ce găsești aici */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite text-rise-white" data-id="element-463">
        <div className="max-w-rise-content mx-auto" data-id="element-464">
          <div className="text-center mb-16" data-id="element-465">
            <div className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-466">
              CE INCLUDE
            </div>
            <h2 className="font-playfair text-[32px] md:text-[42px] mb-4" data-id="element-467">
              Ce găsești în interiorul Comunității
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-468">
            <DarkCard title="Întâlniri Live" icon={<Calendar size={32} data-id="element-470" />} data-id="element-469">
              2 întâlniri de grup pe lună (Zoom) pe teme specifice de dezvoltare
              personală, cu sesiune de Q&A.
            </DarkCard>
            <DarkCard title="Grup Privat" icon={<MessageCircle size={32} data-id="element-472" />} data-id="element-471">
              Acces la grupul privat de Telegram unde interacționăm zilnic,
              împărtășim resurse și ne susținem.
            </DarkCard>
            <DarkCard title="Meditații" icon={<Sparkles size={32} data-id="element-474" />} data-id="element-473">
              O bibliotecă în continuă creștere de meditații ghidate și practici
              de reglare a sistemului nervos.
            </DarkCard>
            <DarkCard title="Provocări" icon={<Heart size={32} data-id="element-476" />} data-id="element-475">
              Provocări lunare (ex: 21 de zile de recunoștință) pentru a integra
              noile obiceiuri în viața de zi cu zi.
            </DarkCard>
          </div>
        </div>
      </section>

      {/* 4. Cum funcționează - center timeline with alternating sides */}
      <section className="py-12 md:py-20 px-6 bg-rise-white text-rise-black" data-id="element-477">
        <div className="max-w-rise-content mx-auto" data-id="element-478">
          <div className="text-center mb-16" data-id="element-479">
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black mb-4" data-id="element-480">
              Cum funcționează?
            </h2>
          </div>

          <div className="relative max-w-4xl mx-auto" data-id="element-481">
            {/* Vertical center line (desktop) + left line (mobile) */}
            <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-rise-gold/40 md:-translate-x-1/2" data-id="element-482"></div>

            <div className="space-y-12 md:space-y-20" data-id="element-483">
              {/* Step 1 - LEFT on desktop */}
              <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-484">
                {/* Dot on the line */}
                <div className="absolute left-6 md:left-1/2 top-6 md:top-1/2 w-5 h-5 rounded-full bg-rise-gold border-4 border-rise-white shadow-md -translate-x-1/2 md:-translate-y-1/2 z-10" data-id="element-485"></div>

                <div className="pl-16 md:pl-0 md:pr-12 md:text-right" data-id="element-486">
                  <div className="font-playfair text-rise-gold text-[44px] md:text-[56px] leading-none mb-3" data-id="element-487">
                    1
                  </div>
                  <h3 className="font-playfair text-[26px] text-rise-black mb-3" data-id="element-488">
                    Te înscrii
                  </h3>
                  <p className="font-dm-sans text-[17px] text-rise-gray leading-relaxed" data-id="element-489">
                    Alegi abonamentul lunar și primești imediat acces la
                    platformă și la grupul de Telegram. Procesul este simplu și
                    durează doar câteva minute.
                  </p>
                </div>
                <div className="hidden md:block" data-id="element-490"></div>
              </div>

              {/* Step 2 - RIGHT on desktop */}
              <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-491">
                <div className="absolute left-6 md:left-1/2 top-6 md:top-1/2 w-5 h-5 rounded-full bg-rise-gold border-4 border-rise-white shadow-md -translate-x-1/2 md:-translate-y-1/2 z-10" data-id="element-492"></div>

                <div className="hidden md:block" data-id="element-493"></div>
                <div className="pl-16 md:pl-12" data-id="element-494">
                  <div className="font-playfair text-rise-gold text-[44px] md:text-[56px] leading-none mb-3" data-id="element-495">
                    2
                  </div>
                  <h3 className="font-playfair text-[26px] text-rise-black mb-3" data-id="element-496">
                    Te conectezi
                  </h3>
                  <p className="font-dm-sans text-[17px] text-rise-gray leading-relaxed" data-id="element-497">
                    Te prezinți în grup, cunoști ceilalți membri și participi la
                    prima ta întâlnire live. Construim împreună un spațiu de
                    încredere.
                  </p>
                </div>
              </div>

              {/* Step 3 - LEFT on desktop */}
              <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-498">
                <div className="absolute left-6 md:left-1/2 top-6 md:top-1/2 w-5 h-5 rounded-full bg-rise-gold border-4 border-rise-white shadow-md -translate-x-1/2 md:-translate-y-1/2 z-10" data-id="element-499"></div>

                <div className="pl-16 md:pl-0 md:pr-12 md:text-right" data-id="element-500">
                  <div className="font-playfair text-rise-gold text-[44px] md:text-[56px] leading-none mb-3" data-id="element-501">
                    3
                  </div>
                  <h3 className="font-playfair text-[26px] text-rise-black mb-3" data-id="element-502">
                    Evoluezi
                  </h3>
                  <p className="font-dm-sans text-[17px] text-rise-gray leading-relaxed" data-id="element-503">
                    Integrezi practicile în ritmul tău, susținut de energia
                    grupului și de ghidarea mea continuă. Fiecare lună aduce un
                    pas nou de progres.
                  </p>
                </div>
                <div className="hidden md:block" data-id="element-504"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Valoarea pe care o primești - unified card */}
      <section className="py-12 md:py-20 px-6 bg-rise-white text-rise-black border-t border-gray-100" data-id="element-505">
        <div className="max-w-3xl mx-auto" data-id="element-506">
          <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black mb-10 text-center" data-id="element-507">
            Valoarea pe care o primești
          </h2>

          <div className="bg-white border border-gray-200 shadow-sm rounded-2xl p-8 md:p-12" data-id="element-508">
            <p className="font-playfair italic text-rise-gold text-[20px] md:text-[22px] mb-8 leading-relaxed" data-id="element-509">
              "Suntem media celor 5 oameni cu care ne petrecem cel mai mult
              timp."
            </p>
            <p className="font-dm-sans text-[17px] text-rise-gray leading-relaxed mb-8" data-id="element-510">
              Alege conștient mediul în care te dezvolți. Comunitatea R.I.S.E.
              este concepută pentru a ridica standardul și a te inspira să devii
              cea mai bună versiune a ta.
            </p>

            <ul className="space-y-4" data-id="element-511">
              <li className="flex items-start gap-3" data-id="element-512">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={20} data-id="element-513" />
                <span className="font-dm-sans text-[16px] text-rise-black leading-relaxed" data-id="element-514">
                  Un spațiu sigur unde poți fi vulnerabil fără teama de a fi
                  judecat.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-515">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={20} data-id="element-516" />
                <span className="font-dm-sans text-[16px] text-rise-black leading-relaxed" data-id="element-517">
                  Răspunsuri la întrebările tale direct de la mine în sesiunile
                  live.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-518">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={20} data-id="element-519" />
                <span className="font-dm-sans text-[16px] text-rise-black leading-relaxed" data-id="element-520">
                  Acces la o rețea de oameni cu preocupări similare (networking
                  de calitate).
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-521">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={20} data-id="element-522" />
                <span className="font-dm-sans text-[16px] text-rise-black leading-relaxed" data-id="element-523">
                  Motivație constantă pentru a nu renunța la procesul tău de
                  creștere.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-524">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={20} data-id="element-525" />
                <span className="font-dm-sans text-[16px] text-rise-black leading-relaxed" data-id="element-526">
                  Reduceri exclusive la programele și retreat-urile R.I.S.E.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* 6. Pentru cine este */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite text-rise-white" data-id="element-527">
        <div className="max-w-rise-content mx-auto text-center" data-id="element-528">
          <h2 className="font-playfair text-[32px] md:text-[42px] mb-12" data-id="element-529">
            Această comunitate este pentru tine dacă:
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left" data-id="element-530">
            <DarkCard title="Ești dedicat creșterii tale" data-id="element-531">
              Nu cauți soluții magice peste noapte, ci ești dispus să depui
              munca necesară pentru a te transforma, pas cu pas.
            </DarkCard>
            <DarkCard title="Apreciezi autenticitatea" data-id="element-532">
              Vrei relații reale, profunde, dincolo de discuțiile superficiale
              de zi cu zi.
            </DarkCard>
            <DarkCard title="Ești deschis să înveți" data-id="element-533">
              Ai o minte deschisă, ești dispus să îți pui la îndoială credințele
              și să asculți perspective diferite.
            </DarkCard>
            <DarkCard title="Vrei să oferi și să primești" data-id="element-534">
              Înțelegi că o comunitate funcționează prin schimb de energie: ești
              gata să fii susținut, dar și să îi susții pe ceilalți.
            </DarkCard>
          </div>
        </div>
      </section>

      {/* 7. Pret / Abonament */}
      <section id="abonament" className="py-12 md:py-20 px-6 bg-rise-white text-rise-black" data-id="element-535">
        <div className="max-w-3xl mx-auto text-center" data-id="element-536">
          <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black mb-6" data-id="element-537">
            Alege să faci parte din trib
          </h2>
          <div className="bg-white border-2 border-rise-gold rounded-2xl p-8 md:p-12 relative overflow-hidden shadow-xl text-rise-black" data-id="element-538">
            <div className="inline-block bg-rise-gold text-rise-black text-[12px] font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-6" data-id="element-539">
              FĂRĂ PERIOADĂ CONTRACTUALĂ
            </div>

            <div className="flex flex-col items-center gap-2 mb-8" data-id="element-540">
              <div className="flex items-baseline justify-center gap-3 flex-wrap" data-id="element-541">
                <span className="text-[26px] md:text-[28px] text-rise-gray line-through font-playfair" data-id="element-542">
                  249 lei
                </span>
                <span className="text-[48px] md:text-[56px] font-playfair text-rise-black leading-none" data-id="element-543">
                  49 lei
                </span>
              </div>
              <p className="font-dm-sans text-[16px] text-rise-gray" data-id="element-544">/ lună</p>
              <p className="inline-block bg-rise-gold/15 text-rise-black border border-rise-gold/40 rounded-full px-4 py-1 mt-2 font-dm-sans text-[12px] font-bold uppercase tracking-wider" data-id="element-545">
                Preț special
              </p>
            </div>

            <ul className="text-left space-y-4 mb-8 max-w-md mx-auto" data-id="element-546">
              <li className="flex items-start gap-3" data-id="element-547">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={20} data-id="element-548" />
                <span className="font-dm-sans text-[16px] text-rise-black leading-relaxed" data-id="element-549">
                  2 Întâlniri Live pe lună (Zoom)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-550">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={20} data-id="element-551" />
                <span className="font-dm-sans text-[16px] text-rise-black leading-relaxed" data-id="element-552">
                  Acces la grupul privat de Telegram
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-553">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={20} data-id="element-554" />
                <span className="font-dm-sans text-[16px] text-rise-black leading-relaxed" data-id="element-555">
                  Acces la biblioteca de meditații
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-556">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={20} data-id="element-557" />
                <span className="font-dm-sans text-[16px] text-rise-black leading-relaxed" data-id="element-558">
                  Provocări lunare de dezvoltare
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-559">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={20} data-id="element-560" />
                <span className="font-dm-sans text-[16px] text-rise-black leading-relaxed" data-id="element-561">
                  Poți anula oricând
                </span>
              </li>
            </ul>

            <div className="flex justify-center" data-id="element-562">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-block w-full md:w-auto" data-id="element-563">
                Abonează-te Acum
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 8. Final CTA */}
      <section className="py-14 md:py-24 px-6 bg-rise-black text-center relative overflow-hidden" data-id="element-564">
        <div className="absolute inset-0 opacity-20 pointer-events-none flex items-center justify-center" data-id="element-565">
          <div className="w-[800px] h-[800px] border-[1px] border-rise-gold rounded-full absolute" data-id="element-566"></div>
          <div className="w-[600px] h-[600px] border-[1px] border-rise-gold rounded-full absolute" data-id="element-567"></div>
          <div className="w-[400px] h-[400px] border-[1px] border-rise-gold rounded-full absolute" data-id="element-568"></div>
        </div>
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-569">
          <h2 className="font-playfair text-[32px] md:text-[48px] text-rise-white mb-6" data-id="element-570">
            Te așteptăm alături de noi
          </h2>
          <p className="font-dm-sans text-[19px] text-rise-white/80 mb-10" data-id="element-571">
            Fă primul pas către un mediu care te susține să crești și să
            strălucești.
          </p>
          <div className="flex justify-center" data-id="element-572">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors" data-id="element-573">
              Vreau în Comunitate
            </a>
          </div>
        </div>
      </section>
    </div>;
}